document.addEventListener('DOMContentLoaded', function() {
  function updateFacetsTop() {
    const myDiv = document.querySelector("[data-collection-toolbar]");
    if (!myDiv) return;

    const pos = myDiv.getBoundingClientRect().top;
    let finalValue = pos + 54;

    document.documentElement.style.setProperty('--facets-top', finalValue + "px");
  }

  function updateBannerHeights() {
    if (window.innerWidth < 700) return;
    document.querySelectorAll('.collection-block:not(.collection-block--no-banner)').forEach(function(block) {
      var products = block.querySelector('.collection-block__products');
      var cards = Array.from(products.querySelectorAll('product-card'));
      if (cards.length >= 3) {
        var firstCardHeight = cards[0].offsetHeight;
        var thirdCardImg = cards[2].querySelector('.product-card__image');
        var imgHeight = thirdCardImg ? thirdCardImg.offsetHeight : 0;
        var gap = 4;
        var banner = block.querySelector('.collection-block__banner');
        if (banner) {
          banner.style.height = (firstCardHeight + gap + imgHeight) + 'px';
        }
      }
    });
  }

  window.addEventListener("load", () => {
    setTimeout(function(){
      updateFacetsTop();
      updateBannerHeights();
    },400);
  });
  window.addEventListener("scroll", updateFacetsTop);
  window.addEventListener("resize", updateBannerHeights);
});